import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8de9bad6046f12a/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/app/[locale]/partners/[slug]/partner.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de9bad6046f12a/node_modules/next/dist/client/link.js");
